import { useEffect, useMemo, useState } from 'react';
import { Alert, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { Environment } from '../../../shared/environment';
import { FerramentasDaListagemPorFazenda } from '../../../shared/components/ferramentas-da-listagem/FerramentasDaListagemPorFazenda';
import { QuadraDetalhes } from './QuadraDetalhes';
import { IListagemQuadras, QuadrasService } from '../../../shared/services/api/QuadrasService';
import { v4 as uuidv4 } from 'uuid';

export const ListagemDeQuadra: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams(); 
  const [rows, setRows] = useState<IListagemQuadras[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const guuid = uuidv4();
  const [totalCount, setTotalCount] = useState(0);
  const [quadra, setQuadra] = useState(0);
  const [openQuadra, setOpenQuadra] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
  
  const idfazenda = useMemo(() => {
    return searchParams.get('fazenda') || '0'; 
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);
  
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

    const handleCloseQuadra = () => {
      setOpenQuadra(false);
      setIsLoading(true);
      QuadrasService.getAll(pagina, Number(idfazenda))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setTotalCount(result.totalCount);
          setRows(result.data);
        }
      });
    };

  useEffect(() => {
    if (idfazenda != '0') { 
    setOpenQuadra(false);
    setIsLoading(true);
      QuadrasService.getAll(pagina, Number(idfazenda))
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    }else{
      setRows([]);
    }        
  }, [idfazenda, pagina]);
   
  return (
    <LayoutBaseDePagina
      titulo='Listagem de Quadras'
      barraDeFerramentas={
        <FerramentasDaListagemPorFazenda
          textoBotaoNovo='Adicionar'
          mostrarInputFazenda
          aoClicarEmNovo={() => {setQuadra(0); setOpenQuadra(true);}}
          aoMudarFazenda={idFaz => setSearchParams({ fazenda: idFaz.toString(), pagina: '1' }, { replace: true })}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Descrição</TableCell>
              <TableCell>Àrea</TableCell>
              <TableCell>Fazenda</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.codquadra} 
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => {setQuadra(row.codquadra); setOpenQuadra(true);}}
              >
                <TableCell>{row.descricao}</TableCell>
                <TableCell>{row.area}</TableCell>
                <TableCell>{row.fazenda}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > Environment.LIMITE_DE_LINHAS) && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Pagination
                    page={pagina}
                    count={Math.ceil(totalCount / Environment.LIMITE_DE_LINHAS)}
                    onChange={(_, newPage) => setSearchParams({fazenda: idfazenda, pagina: newPage.toString() }, { replace: true })}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
      <QuadraDetalhes
        id={''}
        quadra={quadra}
        codfaz={Number(idfazenda)}
        value={guuid} 
        open={openQuadra} 
        onClose={handleCloseQuadra}
      /> 
    </LayoutBaseDePagina>
  );
};